var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"value":_vm.value,"fullscreen":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[(_vm.value)?_c('DashTableForm',{attrs:{"date-range":_vm.internalDateRange,"dashboard":_vm.dashboard},on:{"saved":function($event){_vm.$emit('input', false)
      _vm.$emit('saved')},"click:cancel":function($event){return _vm.$emit('input', false)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }